import request from '../request'


export function getQuestionsId(crs_id) {
    return request({
        url: `/answer/all/questions?crs_id=${crs_id}`,
        method: 'get',

    })
}